<template>
  <div>
    <v-app-bar color="" dark>
      <v-app-bar-nav-icon @click="setDrawer(!drawer)" />
      <v-tabs show-arrows center-active class="pr-2" optional>
        <v-tab v-for="(item, index) in visibleMenuItems" :key="index" :to="item.to">
          {{ item.name }}
        </v-tab>
      </v-tabs>
      <!-- <v-btn color="secondary" v-if="isDevelopment" @click="makeAPICall">
        api call
      </v-btn> -->
      <label class="mr-5" style="color: gray; font-size: small">{{
        selectedYear?.Year ?? selectedYear
      }}</label>
      <label style="color: gray; font-size: small; width: 10%">{{
        selectedEvent.EventName
      }}</label>
      <global-EventSelectorDesktop />
      <!-- <utility-LogoutButton outlined class="d-sm-none d-md-flex"/> -->
    </v-app-bar>
    <global-drawer />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { isStockOnlyAccess, hasStock } from "@/utils/permissions";

export default {
  data: () => ({
    menuItems: [
      { name: "Home", to: "/" },
      { name: "Takings", to: "/Takings" },
      { name: "Product Sales", to: "/ProductSales" },
      { name: "Transactions", to: "/Transactions" },
      { name: "Devices", to: "/Devices" },
      // { name: "Stock Levels", to: "/StockLevels" }
    ],
  }),
  computed: {
    ...mapState("app", ["drawer"]),
    ...mapState("filter", [
      "globalYearFilter",
      "globalEventFilter",
      "IsAdmin",
      "userEventPermissions",
    ]),
    stockOnly() {
      if (this.IsAdmin) return false;
      const eventId = this.globalEventFilter?.EventId;
      const acl = (this.userEventPermissions || []).find(
        (e) => e.EventId === eventId
      );
      if (acl) return isStockOnlyAccess(acl);
      // Fallback when logon Events list is missing
      return hasStock(this.globalEventFilter?.Permission);
    },
    visibleMenuItems() {
      if (this.stockOnly) {
        return this.menuItems.filter((item) => item.to === "/Devices");
      }
      return this.menuItems;
    },
    selectedYear: {
      get() {
        return this.globalYearFilter;
      },
      set(value) {
        console.log("YEAR IS CHANGED", value);
      },
    },
    selectedEvent: {
      get() {
        return this.globalEventFilter;
      },
      set(value) {
        console.log("EVENT IS CHANGED MAKE API REQUEST", value);
      },
    },
    isDevelopment: function () {
      return process.env.NODE_ENV == "development";
    },
  },
  watch: {
    stockOnly: {
      handler(stockOnly) {
        this.redirectStockOnly();
        return stockOnly;
      },
      immediate: true,
    },
    $route() {
      this.redirectStockOnly();
    },
  },
  methods: {
    ...mapMutations("app", ["setDrawer"]),
    redirectStockOnly() {
      if (!this.stockOnly) return;
      const allowed = ["/Devices", "/login"];
      if (!allowed.includes(this.$route.path)) {
        this.$router.replace("/Devices");
      }
    },
    // ...mapActions('dashboard', ['updateDashboard']),
    // ...mapMutations('filter', [
    //   // 'setGlobalYearFilter',
    //   'setGlobalEventFilter']),
    // makeAPICall() {
    //   this.updateDashboard()
    // }
  },
};
</script>

<style></style>
